import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { TypeViewEnum } from "../models";
export interface ICommonState {
  isHasLoad: boolean;
  isShowFullMenu: boolean;
  typeView: TypeViewEnum | null;
  isLoadingTable: boolean;
}

const initialState: ICommonState = {
  isHasLoad: true,
  isShowFullMenu: true,
  typeView: TypeViewEnum.Table,
  isLoadingTable: false,
};

const commonSlice = createSlice({
  name: "common",
  initialState,
  reducers: {
    handleToggleMenu: (state) => {
      state.isShowFullMenu = !state.isShowFullMenu;
    },
    handleSetShowFullMenu: (state, action: PayloadAction<boolean>) => {
      state.isShowFullMenu = action.payload;
    },
    handleSetTypeView: (state, action: PayloadAction<TypeViewEnum | null>) => {
      state.typeView = action.payload;
    },
    handleSetLoadingTable: (state, action: PayloadAction<boolean>) => {
      state.isLoadingTable = action.payload;
    },
  },
});
export const commonActions = { ...commonSlice.actions };
const commonReducer = commonSlice.reducer;
export default commonReducer;
